import React from "react";
import { useTheme } from "../../../Hooks";
import { FmBasicModal } from "../..";
import { FmButton } from "../../FmButton";
import { useTranslation } from "react-i18next";
import useStyles from "./FmErrorModal.style";

interface FmErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
  data?: string;
}

const FmErrorModal = ({ isOpen, onClose, data }: FmErrorModalProps) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const classes = useStyles();

  const renderModal = () => {
    return (
      <FmBasicModal img={theme.images.errorApiModal} onClose={onClose} isOpen={isOpen} contentStyle={classes.content}>
        <div className={classes.container}>
          <div className={classes.upperBody}>
            <div className={classes.title}></div>
            <div className={classes.body}>{data}</div>
          </div>

          <div className={classes.bottomBody}>
            <FmButton fullWidth={"regular"} onClick={onClose}>
              {t("general.tryAgain")}
            </FmButton>
          </div>
        </div>
      </FmBasicModal>
    );
  };
  return <div>{renderModal()}</div>;
};

export default FmErrorModal;
